import { DesignEntity } from '@/lib/enums';

export default function iterateHierarchy({ snapshot, id, type, map }) {
  const plural = DesignEntity.toPlural(type);
  const entity = snapshot.entities?.[plural][id];

  if (!entity) {
    return;
  }

  map.get(type).set(id, entity);
  const entityChildren = [];

  entity.__children?.forEach((type, id) => {
    const items = iterateHierarchy({
      snapshot,
      id,
      map,
      type,
    });

    if (!items) {
      return;
    }

    entityChildren.push(items);
  });

  return {
    uuid: entity.uuid,
    type,
    children: entityChildren,
  };
}
